import { Navigate, useLocation } from "react-router";

import { routes } from "~/routes";

export function LegacyFilesRedirect() {
  const { pathname, search, hash } = useLocation();
  const nextPathname = pathname.replace(/^\/files(?=\/|$)/, routes.Resources);
  return <Navigate to={{ pathname: nextPathname, search, hash }} replace />;
}
